module.exports = __webpack_public_path__ + "img/logoLC.4042c6f6.png";